import { createSelectors } from "@/redux/helpers/selector";

import { MODULE } from "./constants";

export const [getCurrentUser] = createSelectors(MODULE, ["currentUser"]);
